<mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex">
  <mat-tab label="Information">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
  <!-- Two-column row: Basic Information | Other Information -->
  <div class="container">
    <div class="left-container">
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Basic Information
        </div>
        <div class="section-content">
          <div class="form-field-container form-field-container-with-columns">
            <div class="form-field-container-half">
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Full Name</mat-label>
                  <input matInput formControlName="fullName" required appTextNormalize>
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field" [class.auto-fill-flash]="titleAutoFilled">
                  <mat-label>Title</mat-label>
                  <mat-select formControlName="honorificTitle" [compareWith]="compareById">
                    <mat-option *ngFor="let honorificTitle of honorificTitles" [value]="honorificTitle">
                      {{ honorificTitle.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="form-field-container-half">
              <div class="photo-upload-container">
                <div class="photo-upload-content">
                  <div class="photo-preview-container">
                    <div class="photo-preview" *ngIf="getCurrentPhotoUrl(); else noPhotoTemplate">
                      <img [src]="getCurrentPhotoUrl()" alt="Profile Photo" class="profile-image clickable" (click)="onPhotoClick()">
                      <button mat-icon-button class="photo-remove-button" (click)="onRemovePhoto()" type="button">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                    <ng-template #noPhotoTemplate>
                      <div class="photo-placeholder">
                        <mat-icon>person</mat-icon>
                        <span>No photo selected</span>
                      </div>
                    </ng-template>
                  </div>
                  <div class="photo-upload-left">
                    <input #fileInput type="file" accept="image/*" (change)="onPhotoSelected($event)" (cancel)="onFileInputCancel($event)" (click)="$event.stopPropagation()" style="display: none">
                    <button mat-raised-button type="button" (click)="onChoosePhotoClick($event, fileInput)" class="photo-upload-button">
                      <mat-icon>photo_camera</mat-icon>
                      {{ hasPhoto() ? 'Change Photo' : 'Choose Photo' }}
                    </button>
                  </div>
                </div>
            </div>
            </div>
          </div>
          <div class="form-field-container form-field-container-with-columns">
            <div class="form-field-container-quarter">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Year of Birth</mat-label>
              <input matInput formControlName="yearOfBirth" type="number">
            </mat-form-field>
            </div>
            <div class="form-field-container-quarter">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Age</mat-label>
              <input matInput formControlName="age" type="number" min="18" max="110">
              @if (form.get('age')?.value && (form.get('age')?.value < 18 || form.get('age')?.value > 110)) {
                <mat-error>Age must be between 18 and 110</mat-error>
              }
            </mat-form-field>
            </div>
            <div class="form-field-container-half form-field-align-end">
              <mat-checkbox formControlName="yearOfBirthConfirmed">Year of Birth Confirmed</mat-checkbox>
            </div>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Gender</mat-label>
              <mat-select formControlName="gender">
                <mat-option *ngFor="let gender of genderOptions" [value]="gender.value">
                  {{ gender.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field-container form-field-container-with-columns">
            <div class="form-field-container-half">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Nationality</mat-label>
                <mat-select formControlName="nationality" [compareWith]="compareById">
                  <mat-option *ngFor="let nationality of nationalities" [value]="nationality">
                    {{ nationality.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field clearable-select-field">
              <mat-label>Secondary Nationality</mat-label>
              <mat-select formControlName="secondNationality" [compareWith]="compareById">
                <mat-option *ngFor="let nationality of nationalities" [value]="nationality">
                  {{ nationality.name }}
                </mat-option>
              </mat-select>
              @if (form.get('secondNationality')?.value) {
                <button matSuffix mat-icon-button type="button" tabindex="-1"
                        aria-label="Clear secondary nationality"
                        (click)="$event.stopPropagation(); clearField('secondNationality')">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
            </div>
          </div>
          <div class="form-field-container form-field-container-with-columns">
            <div class="form-field-container-column">
              <mat-checkbox formControlName="isDeceased">Passed Away</mat-checkbox>
            </div>
            <div class="form-field-container-column flex-grow" *ngIf="form.get('isDeceased')?.value">
              <mat-form-field appearance="fill" class="full-width-field">
              <mat-label>Passed Away Date</mat-label>
              <input matInput [matDatepicker]="deathDatePicker" formControlName="dateOfDeath">
              <mat-datepicker-toggle matIconSuffix [for]="deathDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #deathDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="right-container">
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Other Information
        </div>
        <div class="section-content">
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field clearable-select-field">
              <mat-label>Profession</mat-label>
              <mat-select formControlName="profession" [compareWith]="compareById">
                <mat-option *ngFor="let profession of professions" [value]="profession">
                  {{ profession.name }}
                </mat-option>
              </mat-select>
              @if (form.get('profession')?.value) {
                <button matSuffix mat-icon-button type="button" tabindex="-1"
                        aria-label="Clear profession"
                        (click)="$event.stopPropagation(); clearField('profession')">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field clearable-select-field">
              <mat-label>Industry Expertise 1</mat-label>
              <mat-select formControlName="industryExpertise1" [compareWith]="compareById">
                <mat-option *ngFor="let industryExpertise of industryExpertises" [value]="industryExpertise">
                  {{ industryExpertise.name }}
                </mat-option>
              </mat-select>
              @if (form.get('industryExpertise1')?.value) {
                <button matSuffix mat-icon-button type="button" tabindex="-1"
                        aria-label="Clear industry expertise 1"
                        (click)="$event.stopPropagation(); clearField('industryExpertise1')">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field clearable-select-field">
              <mat-label>Industry Expertise 2</mat-label>
              <mat-select formControlName="industryExpertise2" [compareWith]="compareById">
                <mat-option *ngFor="let industryExpertise of industryExpertises" [value]="industryExpertise">
                  {{ industryExpertise.name }}
                </mat-option>
              </mat-select>
              @if (form.get('industryExpertise2')?.value) {
                <button matSuffix mat-icon-button type="button" tabindex="-1"
                        aria-label="Clear industry expertise 2"
                        (click)="$event.stopPropagation(); clearField('industryExpertise2')">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field clearable-select-field">
              <mat-label>Professional Qualification</mat-label>
              <mat-select formControlName="qualification" [compareWith]="compareById">
                <mat-option *ngFor="let qualification of qualifications" [value]="qualification">
                  {{ qualification.name }}
                </mat-option>
              </mat-select>
              @if (form.get('qualification')?.value) {
                <button matSuffix mat-icon-button type="button" tabindex="-1"
                        aria-label="Clear professional qualification"
                        (click)="$event.stopPropagation(); clearField('qualification')">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-checkbox formControlName="hasFinancialExpertise">Has Financial Expertise</mat-checkbox>
          </div>
          @if (form.get('hasFinancialExpertise')?.value) {
            <div class="form-field-container">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Financial Expertise</mat-label>
                <mat-select formControlName="financialExpertise" [compareWith]="compareById">
                  <mat-option *ngFor="let financialExpertise of financialExpertises" [value]="financialExpertise">
                    {{ financialExpertise.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          }
          <div class="form-field-container">
            <mat-checkbox formControlName="hasPoliticalPosition">Has Political Position</mat-checkbox>
          </div>
          @if (form.get('hasPoliticalPosition')?.value) {
            <div class="form-field-container">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Political Position</mat-label>
                <mat-select formControlName="politicalPosition" [compareWith]="compareById">
                  <mat-option *ngFor="let politicalPosition of politicalPositions" [value]="politicalPosition">
                    {{ politicalPosition.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          }
          <div class="form-field-container">
            <div class="form-field-container-column">
              <mat-checkbox formControlName="isCompleted">Completed</mat-checkbox>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <!-- Full-width sections below -->
  <section class="section-container nrg-border-radius">
    <div class="section-header">
      Curriculum Vitae
    </div>
    <div class="section-content">
      <div class="form-field-container">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Curriculum Vitae Summary</mat-label>
          <textarea matInput formControlName="cvSummary" rows="8"
                    placeholder="Enter the director's curriculum vitae details..."></textarea>
        </mat-form-field>
      </div>
    </div>
  </section>
  <section class="section-container nrg-border-radius">
    <div class="section-header">
      Work Experience
      <button mat-icon-button color="primary" type="button" (click)="onAddWorkExperience()">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-generic-list
        #workExperienceList
        [columnDefinitions]="workExperienceColumnDefinitions"
        [items]="workExperiences"
        [enablePaging]="false"
        [enableEdit]="true"
        [enableDelete]="true"
        (editClick)="onEditWorkExperience($event)"
        (deleteClick)="onDeleteWorkExperience($event)">
      </app-generic-list>
    </div>
  </section>
  <section class="section-container nrg-border-radius">
    <div class="section-header">
      Training & Education
      <button mat-icon-button color="primary" type="button" (click)="onAddTrainingAndEducation()">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-generic-list
        #trainingAndEducationList
        [columnDefinitions]="trainingAndEducationColumnDefinitions"
        [items]="trainingAndEducations"
        [enablePaging]="false"
        [enableEdit]="true"
        [enableDelete]="true"
        (editClick)="onEditTrainingAndEducation($event)"
        (deleteClick)="onDeleteTrainingAndEducation($event)">
      </app-generic-list>
    </div>
  </section>

      @if (!hideActions) {
      <div class="form-actions">
        <button mat-flat-button color="primary" type="button" (click)="onSubmit()" [disabled]="!form.valid">
          <mat-icon>save</mat-icon>
          {{ submitButtonText }}
        </button>
        <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onCancel()">
          <mat-icon>clear</mat-icon>
          Cancel
        </button>
      </div>
      }
    </form>
    </mat-tab>
    <mat-tab label="Positions" *ngIf="isEditMode">
      <div class="positions-container">
        <div class="positions-view-toggle">
          <mat-button-toggle-group [(value)]="positionsViewMode" hideSingleSelectionIndicator>
            <mat-button-toggle value="year">By Year</mat-button-toggle>
            <mat-button-toggle value="company">By Company</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        @if (positionsViewMode === 'year') {
          <!-- BY YEAR VIEW -->
          <!-- Board Positions -->
          <div class="positions-section">
            <h3 class="positions-section-title">Board Positions</h3>
            @if (boardPositionsByYear.length === 0) {
              <div class="empty-state">No board positions available</div>
            }
            @for (group of boardPositionsByYear; track group.year) {
              <section class="section-container nrg-border-radius">
                <div class="section-header">Year: {{ group.year }}</div>
                <div class="section-content">
                  <div class="positions-list">
                    <table mat-table [dataSource]="group.positions" class="mat-elevation-z2 board-table">
                      <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let pos">
                          <span class="name-cell">
                            @if (openLinksInNewTab) {
                              <a [href]="getCompanyUrl(pos.companyId, {tab: 'board', year: group.year})" target="_blank" class="company-link-btn" title="Go to board tab" (click)="$event.stopPropagation()">
                                <mat-icon>open_in_new</mat-icon>
                              </a>
                            } @else {
                              <a [routerLink]="['/companies/edit', pos.companyId]" [queryParams]="{tab: 'board', year: group.year}" class="company-link-btn" title="Go to board tab" (click)="$event.stopPropagation()">
                                <mat-icon>open_in_new</mat-icon>
                              </a>
                            }
                            {{ pos.companyName }}
                          </span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="classification">
                        <th mat-header-cell *matHeaderCellDef>Classification</th>
                        <td mat-cell *matCellDef="let pos">{{ getClassificationLabel(pos.classification) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="occupationName">
                        <th mat-header-cell *matHeaderCellDef>Occupation</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.occupationName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="tenure">
                        <th mat-header-cell *matHeaderCellDef>Tenure</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.tenure }}</td>
                      </ng-container>
                      <ng-container matColumnDef="meetingAttendancePercentage">
                        <th mat-header-cell *matHeaderCellDef>M.A. %</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.meetingAttendancePercentage) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="forVotesPct">
                        <th mat-header-cell *matHeaderCellDef>For%</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.forVotesPct) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="againstVotesPct">
                        <th mat-header-cell *matHeaderCellDef>Against%</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.againstVotesPct) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="auditCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Audit</th>
                        <td mat-cell *matCellDef="let pos">{{ getAuditRoleLabel(pos.auditCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="remunerationCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Remuneration</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.remunerationCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="nominationCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Nomination</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.nominationCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="cgCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>C.G.</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.cgCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shares">
                        <th mat-header-cell *matHeaderCellDef>Shares</th>
                        <td mat-cell *matCellDef="let pos">{{ formatNumber(pos.firstClassShares) }}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="boardDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: boardDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </section>
            }
          </div>

          <!-- Executive Management -->
          <div class="positions-section">
            <h3 class="positions-section-title">Executive Management</h3>
            @if (executivePositionsByYear.length === 0) {
              <div class="empty-state">No executive positions available</div>
            }
            @for (group of executivePositionsByYear; track group.year) {
              <section class="section-container nrg-border-radius">
                <div class="section-header">Year: {{ group.year }}</div>
                <div class="section-content">
                  <div class="positions-list">
                    <table mat-table [dataSource]="group.positions" class="mat-elevation-z2 executive-table">
                      <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let pos">
                          <span class="name-cell">
                            @if (openLinksInNewTab) {
                              <a [href]="getCompanyUrl(pos.companyId, {tab: 'board', year: group.year})" target="_blank" class="company-link-btn" title="Go to board tab" (click)="$event.stopPropagation()">
                                <mat-icon>open_in_new</mat-icon>
                              </a>
                            } @else {
                              <a [routerLink]="['/companies/edit', pos.companyId]" [queryParams]="{tab: 'board', year: group.year}" class="company-link-btn" title="Go to board tab" (click)="$event.stopPropagation()">
                                <mat-icon>open_in_new</mat-icon>
                              </a>
                            }
                            {{ pos.companyName }}
                          </span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="occupationName">
                        <th mat-header-cell *matHeaderCellDef>Occupation</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.occupationName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="tenure">
                        <th mat-header-cell *matHeaderCellDef>Tenure</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.tenure }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shares">
                        <th mat-header-cell *matHeaderCellDef>Shares</th>
                        <td mat-cell *matCellDef="let pos">{{ formatNumber(pos.firstClassShares) }}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="executiveDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: executiveDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </section>
            }
          </div>
        }

        @if (positionsViewMode === 'company') {
          <!-- BY COMPANY VIEW -->
          <!-- Board Positions -->
          <div class="positions-section">
            <h3 class="positions-section-title">Board Positions</h3>
            @if (boardPositionsByCompany.length === 0) {
              <div class="empty-state">No board positions available</div>
            }
            @for (group of boardPositionsByCompany; track group.companyId) {
              <section class="section-container nrg-border-radius">
                <div class="section-header">
                  <span class="name-cell">
                    @if (openLinksInNewTab) {
                      <a [href]="getCompanyUrl(group.companyId)" target="_blank" class="company-link-btn" title="Edit company" (click)="$event.stopPropagation()">
                        <mat-icon>open_in_new</mat-icon>
                      </a>
                    } @else {
                      <a [routerLink]="['/companies/edit', group.companyId]" class="company-link-btn" title="Edit company" (click)="$event.stopPropagation()">
                        <mat-icon>open_in_new</mat-icon>
                      </a>
                    }
                    {{ group.companyName }}
                  </span>
                </div>
                <div class="section-content">
                  <div class="positions-list">
                    <table mat-table [dataSource]="group.positions" class="mat-elevation-z2 board-table">
                      <ng-container matColumnDef="year">
                        <th mat-header-cell *matHeaderCellDef>Year</th>
                        <td mat-cell *matCellDef="let pos">
                          @if (openLinksInNewTab) {
                            <a [href]="getCompanyUrl(group.companyId, {tab: 'board', year: pos.year})" target="_blank" class="company-link-btn" title="Go to board tab" (click)="$event.stopPropagation()">
                              {{ pos.year }}
                            </a>
                          } @else {
                            <a [routerLink]="['/companies/edit', group.companyId]" [queryParams]="{tab: 'board', year: pos.year}" class="company-link-btn" title="Go to board tab" (click)="$event.stopPropagation()">
                              {{ pos.year }}
                            </a>
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="classification">
                        <th mat-header-cell *matHeaderCellDef>Classification</th>
                        <td mat-cell *matCellDef="let pos">{{ getClassificationLabel(pos.classification) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="occupationName">
                        <th mat-header-cell *matHeaderCellDef>Occupation</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.occupationName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="tenure">
                        <th mat-header-cell *matHeaderCellDef>Tenure</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.tenure }}</td>
                      </ng-container>
                      <ng-container matColumnDef="meetingAttendancePercentage">
                        <th mat-header-cell *matHeaderCellDef>M.A. %</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.meetingAttendancePercentage) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="forVotesPct">
                        <th mat-header-cell *matHeaderCellDef>For%</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.forVotesPct) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="againstVotesPct">
                        <th mat-header-cell *matHeaderCellDef>Against%</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.againstVotesPct) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="auditCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Audit</th>
                        <td mat-cell *matCellDef="let pos">{{ getAuditRoleLabel(pos.auditCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="remunerationCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Remuneration</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.remunerationCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="nominationCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Nomination</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.nominationCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="cgCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>C.G.</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.cgCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shares">
                        <th mat-header-cell *matHeaderCellDef>Shares</th>
                        <td mat-cell *matCellDef="let pos">{{ formatNumber(pos.firstClassShares) }}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="boardByCompanyDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: boardByCompanyDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </section>
            }
          </div>

          <!-- Executive Management -->
          <div class="positions-section">
            <h3 class="positions-section-title">Executive Management</h3>
            @if (executivePositionsByCompany.length === 0) {
              <div class="empty-state">No executive positions available</div>
            }
            @for (group of executivePositionsByCompany; track group.companyId) {
              <section class="section-container nrg-border-radius">
                <div class="section-header">
                  <span class="name-cell">
                    @if (openLinksInNewTab) {
                      <a [href]="getCompanyUrl(group.companyId)" target="_blank" class="company-link-btn" title="Edit company" (click)="$event.stopPropagation()">
                        <mat-icon>open_in_new</mat-icon>
                      </a>
                    } @else {
                      <a [routerLink]="['/companies/edit', group.companyId]" class="company-link-btn" title="Edit company" (click)="$event.stopPropagation()">
                        <mat-icon>open_in_new</mat-icon>
                      </a>
                    }
                    {{ group.companyName }}
                  </span>
                </div>
                <div class="section-content">
                  <div class="positions-list">
                    <table mat-table [dataSource]="group.positions" class="mat-elevation-z2 executive-table">
                      <ng-container matColumnDef="year">
                        <th mat-header-cell *matHeaderCellDef>Year</th>
                        <td mat-cell *matCellDef="let pos">
                          @if (openLinksInNewTab) {
                            <a [href]="getCompanyUrl(group.companyId, {tab: 'board', year: pos.year})" target="_blank" class="company-link-btn" title="Go to board tab" (click)="$event.stopPropagation()">
                              {{ pos.year }}
                            </a>
                          } @else {
                            <a [routerLink]="['/companies/edit', group.companyId]" [queryParams]="{tab: 'board', year: pos.year}" class="company-link-btn" title="Go to board tab" (click)="$event.stopPropagation()">
                              {{ pos.year }}
                            </a>
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="occupationName">
                        <th mat-header-cell *matHeaderCellDef>Occupation</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.occupationName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="tenure">
                        <th mat-header-cell *matHeaderCellDef>Tenure</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.tenure }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shares">
                        <th mat-header-cell *matHeaderCellDef>Shares</th>
                        <td mat-cell *matCellDef="let pos">{{ formatNumber(pos.firstClassShares) }}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="executiveByCompanyDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: executiveByCompanyDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </section>
            }
          </div>
        }
      </div>
    </mat-tab>
</mat-tab-group>
